import * as React from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';
import CardMedia from '../../shared/cardMedia';
import { useStyles, StyledClearIcon, StyledYellowHeader } from './styles';
import { SingleCarousel } from '../../shared/SingleCarousel/SingleCarousel';

export default function HomeGetStartedSection({ title, sectionData = [], homePage = {}, loading }) {
  const classes = useStyles();
  const [hide, setHide] = React.useState('block');
  const course = sectionData?.length ? sectionData[0] : [];
  let courses = course?.sessions?.filter((k) => k.published) || [];

  if (!courses.length) return null;
  return (
    <Card sx={{ display: hide }}>
      <CardContent sx={{ backgroundColor: '#0C1721' }}>
        <Stack direction="row" justifyContent="space-between" mb={1} p={0.5}>
          <Typography color="secondary" variant="h2">
            {title}
          </Typography>
          <StyledClearIcon
            onClick={() => {
              setHide('none');
            }}
          />
        </Stack>

        {courses?.length >= 3 ? (
          <SingleCarousel
            loading={loading}
            images={courses?.map((k, i) => ({
              id: k.id,
              imageUrl: k?.longTileImage,
              data: k,
              contentType: k.contentType,
            }))}
            isClickable={true}
          />
        ) : (
          <>
            <Grid container spacing={2} p={1}>
              {courses.map((item, i) => (
                <Grid item xl={6} lg={6} key={i}>
                  <CardMedia
                    key={i}
                    src={item?.longTileImage}
                    alt={item?.title}
                    id={item?.id}
                    contentType={item.contentType}
                    data={item}
                    loading={loading}
                    isClickable={true}
                    type={'longTileImage'}
                    style={{ width: '100%' }}
                  />
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </CardContent>
    </Card>
  );
}
